import React from 'react'
import styled from 'styled-components'

import { SkeletonBox } from 'features/charts-v2/components/skeletons/SkeletonBox'

interface FilterCardsSkeletonProps {
  count: number
}

/**
 * Shimmer placeholders standing in for applied filter cards while the
 * project's default filter-option list is loading — `FilterControl` derives
 * `filtersToShow` from `filterOptions`, so an empty options list otherwise
 * renders zero cards even though the panel's `selectedFilterOptions` already
 * knows how many are coming. `count` should be `selectedFilterOptions.length`
 * so the shimmer count matches the real cards and the section doesn't jump
 * when they swap in.
 */
export const FilterCardsSkeleton: React.FC<FilterCardsSkeletonProps> = ({
  count,
}) => {
  if (count <= 0) return null

  return (
    <Stack role="status" aria-label="Loading filters">
      {Array.from({ length: count }, (_, index) => (
        <SkeletonBox key={index} height="52px" />
      ))}
    </Stack>
  )
}

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
